var map = {
	"./decidim/avatar-multiuser.png": 80678,
	"./decidim/brands/google.svg": 24733,
	"./decidim/cc-badge.png": 94568,
	"./decidim/decidim-logo.svg": 46945,
	"./decidim/default-avatar.svg": 71252,
	"./decidim/gamification/badges/decidim_gamification_badges_followers.svg": 4240,
	"./decidim/icons.svg": 24713,
	"./decidim/pattern.png": 25069,
	"./decidim/placeholder.jpg": 60045,
	"./decidim/vendor/leaflet/layers-2x.png": 71092,
	"./decidim/vendor/leaflet/layers.png": 91241,
	"./decidim/vendor/leaflet/marker-icon-2x.png": 81156,
	"./decidim/vendor/leaflet/marker-icon.png": 73247,
	"./decidim/vendor/leaflet/marker-shadow.png": 34547,
	"./decidim/vendor/social-share-button/delicious.svg": 34062,
	"./decidim/vendor/social-share-button/douban.svg": 94119,
	"./decidim/vendor/social-share-button/email.svg": 74905,
	"./decidim/vendor/social-share-button/facebook.svg": 16088,
	"./decidim/vendor/social-share-button/google_bookmark.svg": 6278,
	"./decidim/vendor/social-share-button/google_plus.svg": 58371,
	"./decidim/vendor/social-share-button/hacker_news.svg": 99710,
	"./decidim/vendor/social-share-button/linkedin.svg": 9041,
	"./decidim/vendor/social-share-button/odnoklassniki.svg": 50368,
	"./decidim/vendor/social-share-button/pinterest.svg": 18441,
	"./decidim/vendor/social-share-button/qq.svg": 21370,
	"./decidim/vendor/social-share-button/reddit.svg": 3767,
	"./decidim/vendor/social-share-button/telegram.svg": 69418,
	"./decidim/vendor/social-share-button/tumblr.svg": 31505,
	"./decidim/vendor/social-share-button/twitter.svg": 50669,
	"./decidim/vendor/social-share-button/vkontakte.svg": 46882,
	"./decidim/vendor/social-share-button/wechat.svg": 86028,
	"./decidim/vendor/social-share-button/weibo.svg": 75962,
	"./decidim/vendor/social-share-button/whatsapp.svg": 20308,
	"./decidim/vendor/social-share-button/x.svg": 41458,
	"./decidim/vendor/social-share-button/xing.svg": 48528
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 42503;